
import setAuthorizationToken from "../../utils/setAutorization";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import jwtDecode from "jwt-decode";
import {
  SIGNIN_USER_SUCCESS,
  SIGNIN_USER_REQUEST,
  SIGNIN_USER_ERROR,
  SET_ADMIN_USER,
  SIGNOUT_USER,
  SET_CURRENT_USER,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAIL,
  USER_REGISTER_REQUEST,
  VENDOR_REGISTER_REQUEST,
  VENDOR_REGISTER_SUCCESS,
  VENDOR_REGISTER_FAIL,
  VERIFY_RESET_OTP_REQUEST,
  VERIFY_RESET_OTP_SUCCESS,
  VERIFY_RESET_OTP_FAIL,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAIL,
  VENDOR_VERIFY_OTP_REQUEST,
  VENDOR_VERIFY_OTP_SUCCESS,
  VENDOR_VERIFY_OTP_FAIL,
  FORGOT_PASS_REQUEST,
  FORGOT_PASS_SUCCESS,
  FORGOT_PASS_FAIL,
  NEW_PASS_UPDATE_REQUEST,
  NEW_PASS_UPDATE_SUCCESS,
  NEW_PASS_UPDATE_FAIL,

} from "../constants/AuthConstant";

const axios = require("axios");
// Login User and Vendor
const baseUrl = process.env.REACT_APP_API_PATH

export const signinUser = (data) => {
  return async function (dispatch) {
    try {
      dispatch({ type: SIGNIN_USER_REQUEST, payload: true });

      const OPTIONS = {
        url: `${baseUrl}/login`,
        method: "POST",
        data: data,
        headers: { "content-type": "application/json" },
      };

      const res = await axios(OPTIONS);
      // console.log("LOGIN RESPONSE====>>> ", res.data);

      const { token, candidateId, vendorId, userType, email, firstName, lastName, logo, profileImageUrl, adminId, } = res.data.data;

      localStorage.setItem("firstName", firstName);
      localStorage.setItem("lastName", lastName);
      localStorage.setItem("email", email);
      localStorage.setItem("usertype", userType);
      localStorage.setItem("userid", candidateId);
      localStorage.setItem("vendorid", vendorId);
      localStorage.setItem("token", token);
      localStorage.setItem("adminid", adminId);
      localStorage.setItem("logo", logo);
      localStorage.setItem('adminProfile', profileImageUrl)

      setAuthorizationToken(token);
      dispatch(setCurrentUser(jwtDecode(token)));
      const userInfo = {
        firstName,
        lastName,
        email,
        usertype: userType,
        userid: candidateId,
        vendorid: vendorId,
        token,
        adminid: adminId,
        logo,
        adminProfile: profileImageUrl,
      };
      dispatch({
        type: SIGNIN_USER_SUCCESS,
        payload: userInfo,
        isSigninIn: true,
        msg: res.data.msg,
      });
      if (userType === "ADMIN") {
        toast.success("Admin Logged In!");
      } else {
        toast.success("User Logged In!");
      }

      setTimeout(() => {
        if (userType === "VENDOR") {
          window.location.href = "/vendor_dashboard";
        } else if (userType === "ADMIN") {
          window.location.href = "/admin";
        } else {
          window.location.href = "/candidate_dashboard";
        }
      }, 1000);

      return res.data;
    } catch (error) {
      // console.log("ioioioioioio", error);
      toast.error(error?.response?.data?.status?.message ?? "Internal Server Error");
      dispatch({
        type: SIGNIN_USER_ERROR,
        loading: false,
        payload: false,
        msg: error.msg,
      });
      throw error; 
    }
  };
};

export const signOut = () => {
  return function (dispatch) {
    dispatch({
      type: SIGNIN_USER_REQUEST,
      payload: true,
    });

    localStorage.clear();
    setAuthorizationToken(false);
    dispatch(setCurrentUser({}));
    dispatch({
      type: SIGNOUT_USER,
      isSigninIn: false,
      payload: false,
    });
    toast.success("Logout!");
    window.location.href = "/login";

    dispatch({
      type: SIGNIN_USER_ERROR,
      loading: false,
      payload: "",
    });
  };
};

export const setCurrentUser = (result) => {
  console.log(result, "hello")
  return {
    type: SET_CURRENT_USER,
    payload: false,
    result: result,
  };
};

// Register User


export const register = (
  firstName,
  lastName,
  email,
  password,
  mobile,
  userType,
  countryCode,
  // aadhaar,
  country,
  dialCode
) => {
  return async function (dispatch) {
    dispatch({
      type: USER_REGISTER_REQUEST,
      payload: true,
      loading: true,
    });

    let OPTION = {
      url: `${baseUrl}/ebench/register_Candidate`,
      method: "POST",
      data: {
        firstName,
        lastName,
        email,
        password,
        mobile,
        userType,
        countryCode: countryCode,
        // aadharCardNumber: aadhaar,
        country,
        dialCode
      },
      headers: {
        "content-type": "application/json",
      },
    };
    await axios(OPTION)
      .then((res) => {
        dispatch(registerPre(res.data));
        localStorage.setItem("userInfo", JSON.stringify(res.data));
        return res?.data
      })
      .catch((error) => {
        dispatch({
          type: USER_REGISTER_FAIL,
          payload: false,
          error: error,
          isSignUp: error.success,

        });
        toast.error(
          error?.response?.data?.status?.message ?? "An error occurred",
          { toastId: "candidateRegidterError" } // unique ID for error toast
        );
        throw error;
      });
  };
};

export const registerPre = (data) => {
  setTimeout(() => {
    window.location.href = "";
  }, 1000);
  return {
    type: USER_REGISTER_SUCCESS,
    isSignUp: data.success,
    result: data,
    payload: false,
    loading: false,
  };
};

// Vendor Register
export const VendorRegister = (
  firstName,
  lastName,
  email,
  password,
  mobile,
  countryCode,
  country,
  userType,
  // aadhaar,
  dialCode
) => {
  return async function (dispatch) {
    dispatch({
      type: VENDOR_REGISTER_REQUEST,
      payload: true,
    });

    let OPTION = {
      url: `${process.env.REACT_APP_API_PATH}/ebench/register_vendor`,
      method: "POST",
      data: {
        firstName,
        lastName,
        email,
        password,
        mobile,
        countryCode,
        country,
        userType,
        // aadharCardNumber: aadhaar,
        dialCode
      },
      headers: {
        "content-type": "application/json",
      },
    };
    await axios(OPTION)
      .then((res) => {
        dispatch(VendorRegisterPre(res.data));
        localStorage.setItem("userInfo", JSON.stringify(res.data));
        return res?.data
      })
      .catch((error) => {
        dispatch({
          type: VENDOR_REGISTER_FAIL,
          payload: false,
          error: error,
        });
        toast.error(
          error?.response?.data?.status?.message ?? "An error occurred",
          { toastId: "vendorRegidterError" } // unique ID for error toast
        );
        throw error
      });
  };
};

export const VendorRegisterPre = (data) => {
  return {
    type: VENDOR_REGISTER_SUCCESS,
    isSignUp: data.success,
    result: data,
    payload: false,
  };
};

// Otp Verify

export const VerifyOtp = (data) => {
  console.log(data, "newdata")
  return function (dispatch) {
    dispatch({
      type: VERIFY_OTP_REQUEST,
      payload: true,
    });

    let OPTIONS = {
      url: `${baseUrl}/ebench/email_verify`,
      method: "PUT",
      data: data,
      headers: {
        "content-type": "application/json",
      },
    };

    axios(OPTIONS)
      .then((res) => {
        dispatch(setCurrentOtp(res.data));
        dispatch({
          type: VERIFY_OTP_SUCCESS,
          payload: false,
          isSigninIn: true,
          msg: res.data.msg,
        });
      })
      .catch((error) => {
        toast.error(
          error?.response?.data?.status?.message ?? "An error occurred",
          { toastId: "emailverifyError" } // unique ID for error toast
        );
        dispatch({
          type: VERIFY_OTP_FAIL,
          loading: false,
          payload: false,
          msg: error.msg,
        });
      });
  };
};

export const setCurrentOtp = (result) => {
  // toast.success("Verify Done!");
  // setTimeout(() => {
  //   window.location.href = "/login";
  // }, 1000);

  return {
    type: SET_ADMIN_USER,
    payload: false,
    result: result,
  };
};

export const VerifyResetOtpAction = (data) => {

  return function (dispatch) {
    dispatch({
      type: VERIFY_RESET_OTP_REQUEST,
      payload: true,
    });

    let OPTIONS = {
      url: `${process.env.REACT_APP_API_PATH}/verify_reset_password_otp`,
      method: "PUT",
      data: data,
      headers: {
        "content-type": "application/json",
      },
    };

    return new Promise((resolve, reject) => {
      axios(OPTIONS)
        .then((res) => {
          dispatch(setResetOtp(res.data));
          dispatch({
            type: VERIFY_RESET_OTP_SUCCESS,
            payload: false,
            isSigninIn: true,
            msg: res.data.msg,
          });
          resolve(res.data)
        })
        .catch((error) => {
          toast.error(
            error?.response?.data?.status?.message ?? "An error occurred",
            { toastId: "resetpassError" } // unique ID for error toast
          );

          dispatch({
            type: VERIFY_RESET_OTP_FAIL,
            loading: false,
            payload: false,
            msg: error.msg,
          });
          reject(error);
        });
    })

  };
};

export const setResetOtp = (result) => {
  toast.success("Verify Done!");
  // setTimeout(() => {
  //   window.location.href = "/new-password";
  // }, 1000);

  return {
    type: SET_ADMIN_USER,
    payload: false,
    result: result,
  };
};

export const VendorVerifyOtp = (data) => {
  console.log(data, "newdata")
  return function (dispatch) {
    dispatch({
      type: VENDOR_VERIFY_OTP_REQUEST,
      payload: true,
    });

    let OPTIONS = {
      url: `${process.env.REACT_APP_API_PATH}/ebench/vendor_email_verify`,
      method: "PUT",
      data: data,
      headers: {
        "content-type": "application/json",
      },
    };

    axios(OPTIONS)
      .then((res) => {
        dispatch(setVcurrentOtp(res.data));
        dispatch({
          type: VENDOR_VERIFY_OTP_SUCCESS,
          payload: false,
          isSigninIn: true,
          msg: res.data.msg,
        });
      })
      .catch((error) => {
        toast.error(
          error?.response?.data?.status?.message ?? "An error occurred",
          { toastId: "emailveifyError" } // unique ID for error toast
        );
        dispatch({
          type: VENDOR_VERIFY_OTP_FAIL,
          loading: false,
          payload: false,
          msg: error.msg,
        });
      });
  };
};

export const setVcurrentOtp = (result) => {
  // toast.success("Verify Done!");
  // setTimeout(() => {
  //   window.location.href = "/login";
  // }, 1000);

  return {
    type: SET_ADMIN_USER,
    payload: false,
    result: result,
  };
};


export const ForgotPassword = (data) => {
  return (dispatch) => {
    // Dispatching the request action
    dispatch({
      type: FORGOT_PASS_REQUEST,
      payload: true,
    });

    // Axios options
    const OPTIONS = {
      url: `${process.env.REACT_APP_API_PATH}/send_reset_password_otp`,
      method: "PUT",
      data: data,
      headers: {
        "content-type": "application/json",
      },
    };

    // Returning a new Promise
    return new Promise((resolve, reject) => {
      // Axios call
      axios(OPTIONS)
        .then((res) => {
          dispatch(setForgot(res.data));
          dispatch({
            type: FORGOT_PASS_SUCCESS,
            payload: false,
            isSigninIn: true,
            msg: res.data.msg,
          });

          // Resolving the promise after success
          resolve(res?.data);
        })
        .catch((error) => {
          toast.error(
            error?.response?.data?.status?.message ?? "An error occurred",
            { toastId: "forgetError" } // unique ID for error toast
          );
          // Dispatching the failure action
          dispatch({
            type: FORGOT_PASS_FAIL,
            loading: false,
            payload: false,
            msg: error?.msg || "Something went wrong",
          });

          // Rejecting the promise after failure
          reject(error);
        });
    });
  };
};

export const setForgot = (result) => {
  toast.success("OTP send sucessfully!");
  setTimeout(() => {
    // window.location.href = "/verify-reset-otp"
  }, 1000);
  return {
    type: SET_ADMIN_USER,
    payload: false,
    result: result,
  };
};

export const NewPasswordAction = (data) => {
  return function (dispatch) {
    dispatch({
      type: NEW_PASS_UPDATE_REQUEST,
      payload: true,
    });

    let OPTION = {
      url: `${process.env.REACT_APP_API_PATH}/update_password`,
      method: "PUT",
      data: data,
      headers: {
        "content-type": "application/json",
      },
    };

    return new Promise((resolve, reject) => {
      axios(OPTION)
        .then((res) => {
          dispatch(updateNewPassPre(res.data));
          resolve(res?.data)
        })
        .catch((error) => {
          dispatch({
            type: NEW_PASS_UPDATE_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
          toast.error(
            "Failed to load the information",
            { toastId: "updatepassError" } // unique ID for error toast
          );
          return reject(error)
        });
    })

  };
};
export const updateNewPassPre = (data) => {
  toast.success("Updated Successfully!");
  // setTimeout(() => {
  //   window.location.href = "/login";
  // }, 1000)
  return {
    type: NEW_PASS_UPDATE_SUCCESS,
    result: data,
    payload: false,
    msg: "SUCCESS",
  };
};